import './ChatSearchExpansion.scss'

import { useEffect, useState } from 'react'
import { Col, Collapse, Row } from 'react-bootstrap'
import cn from 'classnames'

import SearchResult from 'components/search/SearchResult/SearchResult'
import RembleAvatar from '../../../assets/images/Remble_Logomark-Green-25pGreen.png'

/**
 * Chat Search Expansion component. Used to display chat search result expansions
 */
export default function ChatSearchExpansion({ searchResult }) {
  const [open, setOpen] = useState(false)

  // Update when the search result changes
  useEffect(() => {}, [searchResult])

  // If we don't have any results, return null
  if (!searchResult?.results?.length) return null

  return (
    <div className={cn('chat-message-content expansion', { open })}>
      <Row className='prompt'>
        <Col xs={1} className='p-0 text-right'>
          <img src={RembleAvatar} alt='' width='20' />
        </Col>
        <Col xs={11}>
          <p onClick={_ => setOpen(!open)}>
            {!open ? (
              <>
                I found {searchResult?.results?.length} item
                {searchResult?.results?.length === 1 ? '' : 's'} in my library
                related to <em>{searchResult.term}</em>. Would you like to see{' '}
                {searchResult?.results?.length === 1 ? 'it' : 'them'}?
              </>
            ) : (
              <>
                Here's what I found for "<em>{searchResult.term}</em>"
              </>
            )}
          </p>
        </Col>
      </Row>
      <Collapse in={open}>
        <div className='results'>
          {searchResult?.results?.map((result, index) => (
            <SearchResult result={result} index={index} key={index} />
          ))}
        </div>
      </Collapse>
    </div>
  )
}
